import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IBonusCreateManuallyPayload } from '@modules/players-bonuses/submodules/components/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { PLAYERS_BONUSES_LIST_QUERY_KEY } from '@modules/players-bonuses/constants';
import { PLAYER_BONUS_CREATE_PERMISSIONS } from '@modules/players-bonuses/submodules/create/constants';
import {
  BONUS_MANUALLY_CREATE_API_URL,
  BONUS_MANUALLY_CREATE_MUTATION_KEY,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/constants';
import { useToastStore } from '@modules/toast/store';

export default function useManuallyCreateBonusMutation():
IContextMutationResult<void, Error, IBonusCreateManuallyPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IBonusCreateManuallyPayload>({
    mutationKey: [BONUS_MANUALLY_CREATE_MUTATION_KEY],
    mutationFn: (bonusData) => fetchPost<void>(
      BONUS_MANUALLY_CREATE_API_URL,
      { bonus: bonusData },
      { permission: PLAYER_BONUS_CREATE_PERMISSIONS.PLAYER_BONUS_CREATE },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYERS_BONUSES_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
